import { useAuth } from "contexts/auth";
import { TUserRole } from "configs/routes";

export const usePermissions = () => {
  const { user } = useAuth();
  const roleNames = user?.roles?.map((item) => item.name) || [];
  const hasPermission = (allowedPermissions: TUserRole[]) => {
    return (
      allowedPermissions.length === 0 ||
      roleNames.some((a) => allowedPermissions?.indexOf(a) >= 0)
    );
  };

  return { hasPermission };
};
